import Commons from '../../../../Services/Common/Common';

/**
 * SAF_BASIC_02 (안전작업허가서) 스키마
 * 서버 응답: PascalCase (PM_CD, USER_NM, CREATE_DATE, CONSTRUCTION_NM, STATUS 등)
 * 그리드 데이터: PascalCase 유지 (기존 구조 호환)
 * 저장 시 서버 요청: PascalCase (서버가 기대하는 형식)
 */
export const SAF_BASIC_02_Schema = {
  fields: {
    // 그리드 데이터: PascalCase 유지
    pmCd: { initial: '', label: '작업허가서코드' },
    userNm: { initial: '', label: '성명' },
    createDate: { initial: null, label: '신청일자' },
    constructionNm: { initial: '', label: '공사업체명' },
    status: { initial: '', label: '처리상태' },
    userId: { initial: '', label: '사용자ID' },
    workStartDate: { initial: '', label: '작업시작일자' },
    workEndDate: { initial: '', label: '작업종료일자' },
  },

  mapper: {
    // 안전작업허가서 조회
    search1: {
      CustCd: (_, context) =>
        Commons.EncryptAES(context.search?.custCd || '') || '',
      DepCd: (_, context) =>
        Commons.EncryptAES(context.search?.depCd || '') || '',
      WorkStartDate: (_, context) =>
        Commons.EncryptAES(
          context.search?.workStartDate ||
            context.search?.startDate ||
            ''
        ) || '',
      WorkEndDate: (_, context) =>
        Commons.EncryptAES(
          context.search?.workEndDate || context.search?.endDate || ''
        ) || '',
      Gubun: (_, context) =>
        Commons.EncryptAES(context.search?.gubun || '') || '',
      SearchText: (_, context) =>
        Commons.EncryptAES(context.search?.searchText || '') || '',
    },

    // 안전작업허가서 상세 조회
    search2: {
      PmCd: (_, context) =>
        Commons.EncryptAES(context?.row?.pmCd || '') || '',
    },

    // 안전작업허가서 반려이력 조회
    search3: {
      PmCd: (_, context) =>
        Commons.EncryptAES(context?.row?.pmCd || '') || '',
    },

    // 안전작업허가서 반려/승인 저장 (SaveSafBasic02U2)
    save2: {
      PmCd: (row) => Commons.EncryptAES(row.pmCd || '') || '',
      Gubun: (row) => Commons.EncryptAES(row.gubun || '') || '', // '0': 반려, '1': 부서장 승인, '2': 안전관리자 승인
      ReturnDetail: (row) => Commons.EncryptAES(row.returnDetail || '') || '',
      DepSignPath: (row) => Commons.EncryptAES(row.depSignPath || '') || '',
      SmSignPath: (row) => Commons.EncryptAES(row.smSignPath || '') || '',
      DepHeadId: (row) => Commons.EncryptAES(row.depHeadId || '') || '',
      UserId: (_, context) => context.userInfo?.userid || '',
    },

    // 안전작업허가서 삭제
    delete1: {
      PmCd: (row) => Commons.EncryptAES(row.pmCd || '') || '',
    },
  },
};
